export const logos = {
  ODDSCHECKER: 'OC_LOGO_2.webp?w=213&h=34&fm=webp&q=80',
  ODDSCHECKER_PLUS: 'oc-pro-logo.svg',
} as const;

export type Logos = 'ODDSCHECKER' | 'ODDSCHECKER_PLUS';
